const defaultMessage = '';
export const checkIsDateValid = (value, message = defaultMessage) => {
  const isDateValid = value !== 'Invalid date';
  if (!isDateValid) {
    return message;
  }
};
